<template>
  <ElDialog
    :title="$t('DEVELOPER_TITLES.ADD_DEVELOPER_TITLE')"
    :visible="value"
    width="25%"
    @close="resetAndClose"
  >
    <ElForm
      ref="developer"
      :model="developer"
      :rules="rules"
      label-position="top"
      @submit.native.prevent="submit"
    >
      <ElFormItem :label="$t('DEVELOPER_TITLES.FA_TITLE')" prop="nameFa">
        <ElInput
          v-model="developer.nameFa"
          type="text"
          name="nameFa"
          required
        />
      </ElFormItem>

      <ElFormItem :label="$t('DEVELOPER_TITLES.FA_WEBSITE')" prop="websiteFa">
        <ElInput
          v-model="developer.websiteFa"
          dir="ltr"
          type="text"
          name="websiteFa"
          class="text-latin"
        />
      </ElFormItem>

      <ElFormItem :label="$t('DEVELOPER_TITLES.EN_TITLE')" prop="nameEn">
        <ElInput
          v-model="developer.nameEn"
          type="text"
          name="nameEn"
          class="text-latin"
          required
        />
        <p class="el-form-item__help">
          {{ $t('DEVELOPER_TITLES.NAME_INPUT_DESC') }}
        </p>
      </ElFormItem>

      <ElFormItem :label="$t('DEVELOPER_TITLES.EN_WEBSITE')" prop="websiteEn">
        <ElInput
          v-model="developer.websiteEn"
          dir="ltr"
          type="text"
          name="websiteEn"
          class="text-latin"
        />
      </ElFormItem>

      <ErrorsList v-if="errors" :errors="errors" />

      <!-- dirty hack until ElementUI ends up with a solution -->
      <input v-show="false" type="submit" />
    </ElForm>

    <div slot="footer" class="dialog-footer">
      <ElButton type="primary" :loading="processing" @click.native="submit">
        {{ $t('SAVE') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native="resetAndClose">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import form from '@/mixins/form';
import { DeveloperTitles } from '@/api/api';
import packageName from '@/mixins/packageName';
import ErrorsList from '@@/common/ErrorsList';
import required from '@/utils/validation-rules/required';
import urlValidation from '@/utils/validation-rules/url';

export default {
  name: 'AddDeveloperTitleModal',

  components: { ErrorsList },
  mixins: [form, packageName],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      developer: {
        nameFa: '',
        websiteFa: '',
        nameEn: '',
        websiteEn: '',
      },
      processing: false,
      errors: null,
    };
  },
  computed: {
    rules() {
      return {
        nameFa: required(),
        websiteFa: urlValidation(),
        nameEn: required(),
        websiteEn: urlValidation(),
      };
    },
  },
  methods: {
    resetAndClose() {
      this.resetForm('developer');
      this.$emit('input', false);
    },
    submit() {
      if (!this.isValid('developer')) {
        return false;
      }
      return this.addDeveloperTitle();
    },
    addDeveloperTitle() {
      this.processing = true;

      return DeveloperTitles.save(this.developer)
        .then(({ body: { message, developer } }) => {
          this.$emit('developer-title-added', developer);
          if (message) {
            this.$message.success(message);
          }
          this.errors = null;
          this.resetAndClose();
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          if (errors) {
            this.errors = errors;
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>
